import { render, staticRenderFns } from "./ScreenLogin.vue?vue&type=template&id=9a10ccbe&lang=true&"
import script from "./ScreenLogin.vue?vue&type=script&lang=js&"
export * from "./ScreenLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports